"use strict";
/**
 * AngularJS button interfaces.
 *
 * @packageDocumentation
 * @module Button
 */
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Positions of an icon inside the button.
 */
var IMRButtonIconPosition;
(function (IMRButtonIconPosition) {
    IMRButtonIconPosition[IMRButtonIconPosition["Left"] = 0] = "Left";
    IMRButtonIconPosition[IMRButtonIconPosition["Right"] = 1] = "Right";
})(IMRButtonIconPosition = exports.IMRButtonIconPosition || (exports.IMRButtonIconPosition = {}));
//#endregion
//# sourceMappingURL=button.interfaces.js.map